// extracted by mini-css-extract-plugin
export default {"checkbox":"ToggleInput_checkbox__vqfzu","label":"ToggleInput_label__cNlwZ","hasError":"ToggleInput_hasError__lsgbf","wrapper":"ToggleInput_wrapper__IPfJV"};